export const emailAndNumberStyles = 'text-md-semibold'

export const containerStyles = `flex flex-col w-[360px]`

export const otpDescriptionTextStyles = `text-md-regular`

export const buttonContainerStyles = `w-full mt-6`

export const otpDescriptionWrapperStyles = `flex flex-col text-center`

export const otpTextStyles = `mb-3 font-semibold text-4xl text-center`

export const verifyOtpButtonStyles = `w-full self-center`

export const leftArrowButtonStyles = `mb-6 cursor-pointer self-start rounded-[10px]`

export const errorMessageStyles = `text-sm-regular mt-2 max-w-full text-center`
